export default {
  path: 'usage',
  name: 'subscription/usage',
  props: true,
  meta: { requiresAuth: true },
  component: () => import(/* webpackChunkName: "subscription-show-usage" */ './Usage')
}
